import ReactDOM from 'react-dom/client';

import { root } from '~/preloaded';
import App from '~/app';

import StaticPage from '~/Components/StaticPage/StaticPage';

const STATIC_PAGE = 'static';
const isStaticPage = window.location.pathname.replace(root, '') === STATIC_PAGE;

const container = document.getElementById('app');

if (!container) {
  throw new Error('Root container #app not found');
}

const renderRoot = ReactDOM.createRoot(container);

if (isStaticPage) {
  renderRoot.render(<StaticPage />);
} else {
  renderRoot.render(<App />);
}
